import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useUserCard = () => {
  return useQuery({
    queryKey: ["userCardState"],
    queryFn: async () =>
      callApi({
        path: "usercard",
        command: "",
        data: "{}",
      }),
  });
};
